"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumIncludes = void 0;
const enumIncludes = (enumObj, value) => {
    return Object.values(enumObj).includes(value); // todo improve typing for value
};
exports.enumIncludes = enumIncludes;
//# sourceMappingURL=index.js.map